/* DuraCrafts v3 (Oct 2026): reveal on scroll, rail arrows, and Add to cart on product cards */
  (function(){
    if(window.dcv3)return;window.dcv3=true;
    function go(){
      document.querySelectorAll('.v3').forEach(function(s){s.classList.add('v3--js')});
      var els=document.querySelectorAll('.v3 [data-v3r]');
      if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('is-in')})}
      else{
        var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){x.target.classList.add('is-in');io.unobserve(x.target)}})},{rootMargin:'0px 0px -6% 0px'});
        els.forEach(function(e){io.observe(e)});
      }
      document.querySelectorAll('.v3 [data-v3-track]').forEach(function(t){
        var box=t.closest('[data-v3-rail]');if(!box)return;
        box.querySelectorAll('[data-v3-dir]').forEach(function(b){b.addEventListener('click',function(){t.scrollBy({left:(+b.getAttribute('data-v3-dir'))*t.clientWidth*.8,behavior:'smooth'})})});
      });
    }
    document.addEventListener('click',function(e){
      var b=e.target.closest&&e.target.closest('[data-v3-add-id]');if(!b)return;
      e.preventDefault();
      var r=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
      if(b.classList.contains('is-done')){window.location.href=r+'cart';return}
      b.disabled=true;var label=b.textContent;b.textContent='Adding...';
      fetch(r+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:+b.getAttribute('data-v3-add-id'),quantity:1}]})})
        .then(function(res){if(!res.ok)throw new Error();b.disabled=false;b.classList.add('is-done');b.textContent='Added. View cart';document.dispatchEvent(new CustomEvent('cart:refresh'))})
        .catch(function(){b.disabled=false;b.textContent=label;window.location.href=b.closest('.v3-card').querySelector('a').href});
    });
    if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',go)}else{go()}
  })();
